export class Country {
  constructor(
    public readonly id: string,
    public readonly name: string,
  ) {
  }
}
